<template>
  <v-dialog :value="show" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span style="font-size:16px;">用户条款</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="term" />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="#D04A02" flat @click="handleCancel">取消</v-btn>
        <v-btn color="#D04A02" flat @click="handleOk">同意</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { logic } from '../common/mixin/logic'

export default {
  mixins: [logic]
}
</script>

